<template>
  <div>
    <b-row class='mt-2'>
      <b-col>
        <h4 v-if='item && item.type'>{{item.type.toUpperCase()}}</h4>
      </b-col>
    </b-row>
    <b-row class='mb-2'>
      <b-col>
        <label>Link</label>
        <b-form-input
          :value='item.value.uri'
          @input='(e) => actions.handleItemYoutubeValueChanged(flatPage.id, item.id, "uri", e)'
        />
      </b-col>
    </b-row>
    <b-row class='mb-2'>
      <b-col>
        <label>Wysokość filmu</label>
        <b-form-input
          :value='item.value.height'
          type='number'
          @input='(e) => actions.handleItemYoutubeValueChanged(flatPage.id, item.id, "height", e)'
        />
      </b-col>  
      <b-col>
        <label>Szerokość filmu</label>
        <b-form-input
          :value='item.value.width'
          type='number'
          @input='(e) => actions.handleItemYoutubeValueChanged(flatPage.id, item.id, "width", e)'
        />
      </b-col>
      <b-col>
        <label>Margines dolny</label>
        <b-form-input
          type='number'
          :value='marginBottom'
          @input='(e) => actions.handleItemTextStyleChanged(flatPage.id, item.id, "marginBottom", e)'
        />
      </b-col>
      <b-col>
        <label>Skaluj do ekranu</label>
        <b-form-checkbox
          v-model='item.scale'
          @input='(e) => actions.handleItemYoutubeValueChanged(flatPage.id, item.id, "scale", e)'
          value='1'
          unchecked-value='0'
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>

  import {
    handleItemYoutubeValueChanged,
    handleItemTextStyleChanged,
  } from '@/store/utils.js'
  
  export default {
    props: ['flatPage', 'item'],
    computed: {
      marginBottom() {
        try {
          return this.item.style.marginBottom || 10
        } catch (e) {
          return 10
        }
      },
    },
    data() {
      return {
        actions: {
          handleItemYoutubeValueChanged,
          handleItemTextStyleChanged,
        },
      }
    },
  }
</script>
